export default [
  {
    path: "/menu",
    component: resolve => require(["@/views/menu.vue"], resolve),
    redirect: "/menu/home",
    children: [
      {
        path: "content", // content 父路由
        component: resolve => require(["@/views/content/index.vue"], resolve),
        children: [
          {
            path: "data/list",
            name: "docList",
            component: resolve => require(["@/modules/data/pages/list.vue"], resolve)
          },
          {
            path: "data/edit/:id",
            name: "docEdit",
            component: resolve => require(["@/modules/data/pages/edit.vue"], resolve)
          },
          {
            path: "data/itemize",
            name: "docItemize",
            component: resolve => require(["@/modules/data/pages/itemize.vue"], resolve)
          },
          {
            path: "data/statistics/:id",
            name: "docStatistics",
            component: resolve => require(["@/modules/data/pages/statistics.vue"], resolve)
          }
        ]
      }
    ]
  }
];
